/*
 *
 *  remotes
 *
 */

import api from "../../helpers/Api"
//import constantName from './key'

/**
 *
 * @param {string} metaData
 * @returns
 */

export function loadRecordsMetaData(metaData, method) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

//employee list
export function loadEmployeeList() {
  let payload = { status: "active" }

  return api
    .post(`/get_all_employee_dropdown_list`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

//employee list
export async function loadFreelancerDetails(searchvalue) {
  let payload = { status: "active" }

  if (searchvalue) {
    return await api
      .post(`/freelancer_audit_QC_report_pagination`, searchvalue)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return await api
      .post(`/freelancer_audit_QC_report_pagination`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

//Audit Status list
export function updateAuditStatusDetails(auditStatus) {

  return api
    .post(`/audit_feedBack_teamSchedule`, auditStatus)
    .catch((error) => Promise.reject(error))
}

//Audit Rating list
export function updateAuditRatingDetails(auditRating) {

  return api
    .post(`/audit_feedBack_teamSchedule`, auditRating)
    .catch((error) => Promise.reject(error))
}

//Audit Remarks list
export function updateAuditRemarksDetails(auditRemarks) {

  return api
    .post(`/audit_feedBack_teamSchedule`, auditRemarks)
    .catch((error) => Promise.reject(error))
}

const remotes = {
  loadRecordsMetaData,
  loadEmployeeList,
  loadFreelancerDetails,
  updateAuditStatusDetails,
  updateAuditRatingDetails,
  updateAuditRemarksDetails
}

export default remotes
